.fadedPlaceholder {
  opacity: 0.42;
}

.menuItem {
  font-size: 14px;
}

.menuItem :global(.MuiTypography-root) {
  font-size: 14px;
}
